// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"fe4dfc22","422":"bc93f79f","735":"2b12a828"}[chunkId] + ".chunk.css";
};